import {
  IconButton,
  makeStyles, Paper, Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";


import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import TablePagination from '@material-ui/core/TablePagination';
import Toolbar from '@material-ui/core/Toolbar';

import AdminTitle from "components/admin/smart-visa/AdminTitle";
import ColorButton from "components/common/ColorButton";
import withAdminLayout from "components/HoC/withAdminLayout";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { format } from "date-fns";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { get } from "lodash";
import queryString from "query-string";
import { forwardRef, useEffect, useMemo, useState } from "react";
import "react-grid-layout/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import "react-resizable/css/styles.css";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import DatetimeService from "services/DatetimeService";
import KPIService from "services/KPIService";

import { ArrowBack } from "@material-ui/icons";
import { boiDepartmentId } from "libs/configs/constant";
import usePagination from "libs/hooks/usePagination";
import HistoryLogTable from "pages/admin/kpi-dashboard/components/HistoryLogTable";
import SearchFilterBar from "pages/admin/kpi-dashboard/components/SearchFilterBar";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useCustomStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  wrapBackButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginLeft: -16
  }
}));

function KPIDashboardDetailPage() {
  const classes = useStyles();
  const classesCustomStyles = useCustomStyles();
  const dispatch = useDispatch();
  const params = useParams()
  const history = useHistory()
  const { search } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [_kpiDetails, setKPIDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedDraftId, setSelectedDraftId] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();

  const { jump, currentData, currentPage } = usePagination(
    _kpiDetails || [],
    rowsPerPage,
    0
  );
  const kpiDetails = useMemo(currentData, [currentData])

  const profile = useSelector((state) => state.user.profile);
  const masterData = useSelector(selectMasterData);
  const department = get(masterData, "department", []);

  const queryParams = queryString.parse(search);
  const flDate = DatetimeService.getFirstAndLastDayOfYear(new Date());

  const [startDate, setStartDate] = useState(queryParams.startDate ? new Date(queryParams.startDate) : flDate.firstDate);
  const [endDate, setEndDate] = useState(queryParams.endDate ? new Date(queryParams.endDate) : flDate.lastDate);
  const [departmentId, setDepartmentId] = useState(queryParams.departmentId ? queryParams.departmentId : "");

  const hasDataList = !!(!isLoading && kpiDetails.length);

  const getData = async () => {
    try {
      const _startDate = startDate ? format(new Date(startDate), "yyyy-MM-dd") : undefined;
      const _endDate = endDate ? format(new Date(endDate), "yyyy-MM-dd") : undefined;

      const res = await KPIService.getKPIDashboardDetail({
        stepKPIID: params.stepKPIID,
        startDate: _startDate,
        endDate: _endDate,
        empId: queryParams?.empId,
        departmentId: departmentId,
      })
      setKPIDetails(res.results)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!params.stepKPIID) return

    getData()
  }, [params.stepKPIID])

  useEffect(() => {
    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          department: true,
        })
      );
    }
    mergedFetchData();
  }, [dispatch]);

  const handleClickOpen = (draftId) => {
    setSelectedDraftId(draftId)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = async () => {
    showAdminLoading();
    await getData();
    hideAdminLoading();
  };

  const handleOnClickBack = () => {
    history.push('/admin/kpi-dashboard', {
      ...queryParams
    })
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    jump(0);
  };

  const departmentList = useMemo(() => {
    if (profile.departmentId === boiDepartmentId) {
      return department
    }

    return department.filter((dp) => dp.departmentId === profile.departmentId)
  }, [profile.departmentId, department])

  return (
    <Paper className={classesCustomStyles.paper}>
      <div className={classesCustomStyles.wrapBackButton}>
        <IconButton onClick={handleOnClickBack}>
          <ArrowBack />
        </IconButton>
        <Typography>
          Back
        </Typography>
      </div>

      <AdminTitle title="KPI dashboard details" subTitle={`${queryParams.stepName} Achieve ${queryParams.achieve} case and Not achieve ${queryParams.notachieve} case`} />
      <SearchFilterBar
        department={departmentList}
        showEmployeeField={false}
        startDate={startDate}
        endDate={endDate}
        departmentId={departmentId}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        handleSearch={handleSearch}
        setDepartmentId={setDepartmentId}
      />
      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={10}>
                <Typography variant="h6">KPI detail list</Typography>
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell>No</StyledTableCell>
              <StyledTableCell align="center" style={{ width: 50 }}>
                Doc No.
              </StyledTableCell>
              <StyledTableCell>First name</StyledTableCell>
              <StyledTableCell>Middle name</StyledTableCell>
              <StyledTableCell>Last name</StyledTableCell>
              {/* <StyledTableCell>Email</StyledTableCell> */}
              <StyledTableCell>Staff</StyledTableCell>
              {/* <StyledTableCell>Date</StyledTableCell> */}
              <StyledTableCell>Step</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Log</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow style={{ borderTop: 1 }}>
                <TableCell colSpan={10} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            )}
            {!hasDataList && (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No kpi detail.
                </TableCell>
              </TableRow>
            )}
            {hasDataList && !isLoading && (
              kpiDetails.map((item) => (
                <TableRow key={item.draftId} style={{ borderTop: 1 }}>
                  <TableCell>
                    {item.no}
                  </TableCell>
                  <TableCell>
                    {item.smartNo}
                  </TableCell>
                  <TableCell>
                    {item.firstname ?? '-'}
                  </TableCell>
                  <TableCell>
                    {item.middlename ?? '-'}
                  </TableCell>
                  <TableCell>
                    {item.lastname ?? '-'}
                  </TableCell>
                  {/* <TableCell>
                    {item.email ?? '-'}
                  </TableCell> */}
                  <TableCell>
                    {item.staffFirstname + ' ' + item.staffLastname ?? '-'}
                  </TableCell>
                  {/* <TableCell>
                    {item.kpiDate ? dayjs(item.kpiDate).format('YYYY/MM/DD HH:mm:ss') : '-'}
                  </TableCell> */}
                  <TableCell>
                    {item.stepName ?? '-'}
                  </TableCell>
                  <TableCell>
                    {item.statusname ?? '-'}
                  </TableCell>
                  <TableCell>
                    <ColorButton variant="outlined"
                      color="info"
                      onClick={() => {
                        handleClickOpen(item.draftId)
                      }}>
                      Log
                    </ColorButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          style={{ marginTop: 18 }}
          component="div"
          rowsPerPageOptions={[5, 10, 25]}
          count={_kpiDetails.length}
          page={currentPage}
          onPageChange={(__, toPage) => jump(toPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classesCustomStyles.appBar}>
          <Toolbar>
            {/* <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton> */}
            <Typography variant="h6" className={classesCustomStyles.title}>
              History log
            </Typography>
            <ColorButton autoFocus color="inherit" onClick={handleClose}>
              Close
            </ColorButton>
          </Toolbar>
        </AppBar>
        <div className={classesCustomStyles.paper}>
          <HistoryLogTable draftId={selectedDraftId} />
        </div>
      </Dialog>
    </Paper>
  )
}

export default withAdminLayout(KPIDashboardDetailPage)